import URL from '../url'
import Request from '../request'

export const getBadgesService = () => new Request(URL.API, URL.GET_BADGES).get()

export const getCustomBadgesService = () =>
  new Request(URL.API, URL.CUSTOM_BADGE).get()

export const createCustomBadgeService = data =>
  new Request(URL.API, URL.CUSTOM_BADGE_CREATE).post(data)

export const updateCustomBadgeService = (id, data) =>
  new Request(URL.API, `${URL.CUSTOM_BADGE}/${id}`).put(data)

export const deleteCustomBadgeService = id =>
  new Request(URL.API, `${URL.CUSTOM_BADGE}/${id}`).delete()
